import { h, render, Component } from 'preact'; // eslint-disable-line
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './index.scss';
import IconCopy from '../../icon-copy';
import IconClose from '../IconClose';

// eslint-disable-next-line

const TopPositionBar = ({
    handleCloseComparison,
    hideTopBar,
    clipboardLink,
    topBarConatinerStyle,
}) => {
    const topPositionBarClasses = classNames({
        [styles.topPositionWrapper]: true,
        [styles.hideTopBar]: hideTopBar,
    });
    return (
        <div className={topPositionBarClasses} style={topBarConatinerStyle} key={1}>
            <div className={styles.topPosition}>
                <div className={styles.comparisonInfo}>
                    <div className={styles.comparisonCount}>
                        <IconCopy
                            width={20}
                            height={20}
                            className={styles.copyLinkNotificationBar}
                        />
                        <span className={styles.notificationMessage}>
                            Link with your Agent/Admin ID was copied to clipboard.
                        </span>
                        <a
                            href={clipboardLink}
                            className={styles.notificationLink}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Open in new window
                        </a>
                    </div>
                </div>
                <div className={styles.comparisonActions}>
                    <span className={styles.comparisonCloseIcon} onClick={handleCloseComparison}>
                        <IconClose />
                    </span>
                </div>
            </div>
        </div>
    );
};

TopPositionBar.propTypes = {
    handleCloseComparison: PropTypes.func,
    className: PropTypes.string,
    clipboardLink: PropTypes.string,
    topBarConatinerStyle: PropTypes.object,
    hideTopBar: PropTypes.bool,
};

TopPositionBar.defaultProps = {
    handleCloseComparison: () => {},
    className: '',
    clipboardLink: '#',
    topBarConatinerStyle: null,
};

export default TopPositionBar;
